import {createSlice, PayloadAction, SerializedError} from "@reduxjs/toolkit";
import {RootState} from "./store";

interface AppState {
    error: SerializedError | null;
}

const appSlice = createSlice({
    name: 'app',
    initialState: {error: null} as AppState,
    reducers: {
        clearAppError(state) {
            state.error = null;
        },
        setAppError(state, {payload}: PayloadAction<SerializedError>) {
            state.error = payload
        }
    }
});

export const {clearAppError, setAppError} = appSlice.actions;

export const selectAppError = (state: RootState) => state.app.error

export default appSlice.reducer;